export enum WindowCustomEvent {
  // Messaging
  NewMessage = 'new-message',
  AddNewMessage = 'add-new-message',
}
